/**
 * Single source of truth for the SDK coordinates the dashboard hands developers.
 *
 * These strings were previously inlined in SDKDocs, AppDetail, and Settings, and
 * had drifted to three different Android versions (0.1.1, 0.1.1, 1.0.12) while
 * the published SDK was on 1.0.14. Copy-pasting a stale coordinate is the first
 * thing a developer does during setup, so keep this file in step with
 * `android-sdk/gradle.properties` (VERSION_NAME) and
 * `ios-sdk/Sources/AppStats/Core/SDKInfo.swift` (version) on every release.
 */

/** Latest published Swift SDK release. */
export const APPLE_SDK_VERSION = '1.0.20'

/** Latest published Kotlin SDK release. */
export const ANDROID_SDK_VERSION = '1.0.21'

export const APPLE_SDK_REPO_URL = 'https://github.com/OneThum/AppStats-iOS'
export const ANDROID_SDK_REPO_URL = 'https://github.com/OneThum/AppStats-Android'

/**
 * JitPack coordinate. Releases are tagged without a `v` prefix, so the version
 * string matches the git tag exactly.
 */
export const ANDROID_SDK_COORDINATE = `com.github.OneThum:AppStats-Android:${ANDROID_SDK_VERSION}`

/** Minimum host toolchain each SDK supports, shown in setup instructions. */
export const ANDROID_SDK_REQUIREMENTS = 'Kotlin 2.0+, Android Gradle Plugin 8.x, JDK 17, minSdk 24 (Android 7.0)'
export const APPLE_SDK_REQUIREMENTS = 'Swift 6.0+, Xcode 15.0+'

/** Per-platform minimum OS, keyed by the `platform` value stored on an app. */
export const PLATFORM_REQUIREMENTS: Record<string, string> = {
  ios: 'iOS 16.0+',
  macos: 'macOS 13.0+',
  visionos: 'visionOS 1.0+',
  tvos: 'tvOS 16.0+',
  watchos: 'watchOS 9.0+',
  android: 'Android 7.0+ (API 24+)',
}
